export const ZOOM_PRESETS = [
  { value: 'auto', label: 'Automatisch' },
  { value: 'page-width', label: 'Seitenbreite' },
  { value: 'page-actual', label: 'Originalgröße' },
  { value: 'page-fit', label: 'Seite anpassen' },
  { value: '0.5', label: '50 %' },
  { value: '0.75', label: '75 %' },
  { value: '1', label: '100 %' },
  { value: '1.25', label: '125 %' },
  { value: '1.5', label: '150 %' },
  { value: '2', label: '200 %' },
  { value: '3', label: '300 %' },
  { value: '4', label: '400 %' },
] as const;

/** Zoom modes whose scale is relative to the container and must be recomputed on resize. */
export const RELATIVE_ZOOM_MODES: readonly string[] = ['auto', 'page-width', 'page-fit'];

const NUMERIC_ZOOM_STEPS = [0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4] as const;

export const MIN_ZOOM = NUMERIC_ZOOM_STEPS[0];
export const MAX_ZOOM = NUMERIC_ZOOM_STEPS[NUMERIC_ZOOM_STEPS.length - 1];

export const nextZoomStep = (current: number, direction: 1 | -1): number => {
  if (direction === 1) {
    return NUMERIC_ZOOM_STEPS.find(step => step > current + 0.001) ?? MAX_ZOOM;
  }
  return [...NUMERIC_ZOOM_STEPS].reverse().find(step => step < current - 0.001) ?? MIN_ZOOM;
};
